const routes = [{
  path: '/',
  component: () => import('layouts/MainLayout.vue'),
  children: [
    {
      path: '',
      name: 'web_index',
      component: () => import('pages/Index.vue')
    },
    {
      path: 'dashboard',
      name: 'dashboard',
      component: () => import('pages/dashboard/dashboard.vue'),
      children: [{
        path: 'outbounddashboard',
        name: 'outbounddashboard',
        component: () => import('pages/dashboard/outbound.vue')
      },
      {
        path: 'inbounddashboard',
        name: 'inbounddashboard',
        component: () => import('pages/dashboard/inbound.vue')
      },
      {
        path: 'inboundAndOutbound',
        name: 'inboundAndOutbound',
        component: () => import('pages/dashboard/inboundAndOutbound.vue')
      }
      ]
    },
    {
      path: 'inbound',
      name: 'inbound',
      component: () => import('pages/inbound/inbound.vue'),
      children: [{
        path: 'asn',
        name: 'asn',
        component: () => import('pages/inbound/asn.vue')
      },
      {
        path: 'predeliverystock',
        name: 'predeliverystock',
        component: () => import('pages/inbound/predeliverystock.vue')
      },
      {
        path: 'preloadstock',
        name: 'preloadstock',
        component: () => import('pages/inbound/preloadstock.vue')
      },
      {
        path: 'presortstock',
        name: 'presortstock',
        component: () => import('pages/inbound/presortstock.vue')
      },
      {
        path: 'sortstock',
        name: 'sortstock',
        component: () => import('pages/inbound/sortstock.vue')
      },
      {
        path: 'shortage',
        name: 'shortage',
        component: () => import('pages/inbound/shortage.vue')
      },
      {
        path: 'more',
        name: 'more',
        component: () => import('pages/inbound/more.vue')
      },
      {
        path: 'asnfinish',
        name: 'asnfinish',
        component: () => import('pages/inbound/asnfinish.vue')
      }
      ]
    },
    {
      path: 'productionorder/:pOrderId',
      name: 'productionorder',
      component: () => import('pages/productionorder/productionorder.vue'),
      props: true,
      children: [
        {
          path: 'poItem',
          name: 'poItem'
        },
        {
          path: 'poItemDetail',
          name: 'poItemDetail'

        }

      ]

    },
    {
      path: 'bom/:pOrderId',
      name: 'bom',
      component: () => import('pages/bom/bom.vue'),
      props: true,
      children: [
        {
          path: 'group',
          name: 'group'
        }

      ]

    },
    {
      path: 'po_report/:pOrderId',
      name: 'po_report',
      component: () => import('pages/productionorder/po_report.vue'),
      props: true,
      children: [
        {
          path: 'poreport',
          name: 'poreport',
          component: () => import('pages/productionorder/po_report.vue')
        }
      ]

    },
    {
      path: 'polist',
      name: 'polist',
      component: () => import('pages/productionorder/orderlist.vue'),
      children: [
        {
          path: 'ol',
          name: 'ol',
          component: () => import('pages/productionorder/orderlist.vue')
        },
        {
          path: 'co',
          name: 'co',
          component: () => import('src/pages/productionorder/productionorder.vue')
        },

        // {
        //   path: 'freshorder',
        //   name: 'freshorder',
        //   component: () => import('pages/outbound/freshorder.vue')
        // },
        // {
        //   path: 'neworder',
        //   name: 'neworder',
        //   component: () => import('pages/outbound/neworder.vue')
        // },
        // {
        //   path: 'pickstock',
        //   name: 'pickstock',
        //   component: () => import('pages/outbound/pickstock.vue')
        // },
        // {
        //   path: 'pickedstock',
        //   name: 'pickedstock',
        //   component: () => import('pages/outbound/pickedstock.vue')
        // },
        // {
        //   path: 'pickinglist',
        //   name: 'pickinglist',
        //   component: () => import('pages/outbound/pickinglist.vue')
        // },
        // {
        //   path: 'shippedstock',
        //   name: 'shippedstock',
        //   component: () => import('pages/outbound/shippedstock.vue')
        // },
        // {
        //   path: 'backorder',
        //   name: 'backorder',
        //   component: () => import('pages/outbound/backorder.vue')
        // },
        // {
        //   path: 'pod',
        //   name: 'pod',
        //   component: () => import('pages/outbound/pod.vue')
        // }
      ]
    },
    // {
    //   path: 'outbound',
    //   name: 'outbound',
    //   component: () => import('pages/outbound/outbound.vue'),
    //   children: [{
    //     path: 'dn',
    //     name: 'dn',
    //     component: () => import('pages/outbound/dn.vue')
    //   },
    //   {
    //     path: 'freshorder',
    //     name: 'freshorder',
    //     component: () => import('pages/outbound/freshorder.vue')
    //   },
    //   {
    //     path: 'neworder',
    //     name: 'neworder',
    //     component: () => import('pages/outbound/neworder.vue')
    //   },
    //   {
    //     path: 'pickstock',
    //     name: 'pickstock',
    //     component: () => import('pages/outbound/pickstock.vue')
    //   },
    //   {
    //     path: 'pickedstock',
    //     name: 'pickedstock',
    //     component: () => import('pages/outbound/pickedstock.vue')
    //   },
    //   {
    //     path: 'pickinglist',
    //     name: 'pickinglist',
    //     component: () => import('pages/outbound/pickinglist.vue')
    //   },
    //   {
    //     path: 'shippedstock',
    //     name: 'shippedstock',
    //     component: () => import('pages/outbound/shippedstock.vue')
    //   },
    //   {
    //     path: 'backorder',
    //     name: 'backorder',
    //     component: () => import('pages/outbound/backorder.vue')
    //   },
    //   {
    //     path: 'pod',
    //     name: 'pod',
    //     component: () => import('pages/outbound/pod.vue')
    //   }
    //   ]
    // },
    {
      path: 'stock',
      name: 'stock',
      component: () => import('pages/stock/stock.vue'),
      children: [{
        path: 'stocklist',
        name: 'stocklist',
        component: () => import('pages/stock/stocklist.vue')
      },
      {
        path: 'itemstock',
        name: 'itemstock',
        component: () => import('pages/stock/itemstock.vue')
      },
      {
        path: 'stockbinlist',
        name: 'stockbinlist',
        component: () => import('pages/stock/stockbinlist.vue')
      },
      {
        path: 'emptybin',
        name: 'emptybin',
        component: () => import('pages/stock/emptybin.vue')
      },
      {
        path: 'occupiedbin',
        name: 'occupiedbin',
        component: () => import('pages/stock/occupiedbin.vue')
      },
      {
        path: 'cyclecount',
        name: 'cyclecount',
        component: () => import('pages/stock/cyclecount.vue')
      },
      {
        path: 'cyclecountrecorder',
        name: 'cyclecountrecorder',
        component: () => import('pages/stock/cyclecountrecorder.vue')
      },
      {
        path: 'handcount',
        name: 'handcount',
        component: () => import('pages/stock/handcount.vue')
      },
      {
        path: 'handcountrecorder',
        name: 'handcountrecorder',
        component: () => import('pages/stock/handcountrecorder.vue')
      }
      ]
    },
    // {
    //   path: 'bom',
    //   name: 'bom',
    //   component: () => import('pages/bom/bom.vue'),
    //   children: [{
    //     path: 'bomlist',
    //     name: 'bomlist',
    //     component: () => import('pages/bom/bomlist.vue')
    //   }
    //   ]      
    // },
    {
      path: 'bomlist',
      name: 'bomlist',
      component: () => import('pages/bom/bomlist.vue'),
      children: [{
        path: 'bom',
        name: 'bom',
        component: () => import('pages/bom/bom.vue')
      }
      ] 
    },
    {
      path: 'bom',
      name: 'bom',
      component: () => import('pages/bom/bom.vue'),
      children: [
        {
          path: 'bomedit',
          name: 'bomedit'
        },
      ]
    },
    {
      path: 'bom_report/:pOrderId',
      name: 'bom_report',
      component: () => import('pages/bom/bom_report.vue'),
      props: true,
      children: [
        {
          path: 'bomreport',
          name: 'bomreport',
          component: () => import('pages/bom/bom_report.vue')
        }
      ]

    },    
    {
      path: 'goods',
      name: 'goods',
      component: () => import('pages/goods/goods.vue'),
      children: [{
        path: 'goodslist',
        name: 'goodslist',
        component: () => import('pages/goods/goodslist.vue')
      },
      {
        path: 'goodsunit',
        name: 'goodsunit',
        component: () => import('pages/goods/goodsunit.vue')
      },
      {
        path: 'goodsclass',
        name: 'goodsclass',
        component: () => import('pages/goods/goodsclass.vue')
      },
      {
        path: 'goodsbrand',
        name: 'goodsbrand',
        component: () => import('pages/goods/goodsbrand.vue')
      },
      {
        path: 'goodscolor',
        name: 'goodscolor',
        component: () => import('pages/goods/goodscolor.vue')
      },
      {
        path: 'goodsspecs',
        name: 'goodsspecs',
        component: () => import('pages/goods/goodsspecs.vue')
      },
      {
        path: 'goodsshape',
        name: 'goodsshape',
        component: () => import('pages/goods/goodsshape.vue')
      },
      {
        path: 'goodsorigin',
        name: 'goodsorigin',
        component: () => import('pages/goods/goodsorigin.vue')
      },
      {
        path: 'machinerytools',
        name: 'machinerytools',
        component: () => import('pages/goods/machinerytools.vue')
        },
      {
        path: 'nail',
        name: 'nail',
        component: () => import('pages/goods/nail.vue')
        },
      {
        path: 'packagingshippingmarks',
        name: 'packagingshippingmarks',
        component: () => import('pages/goods/packagingshippingmarks.vue')
        },
      {
        path: 'paintpowderchemicals',
        name: 'paintpowderchemicals',
        component: () => import('pages/goods/paintpowderchemicals.vue')
        },
      {
        path: 'plasticbeadscolor',
        name: 'plasticbeadscolor',
        component: () => import('pages/goods/plasticbeadscolor.vue')
        },
      {
        path: 'sewingmaterials',
        name: 'sewingmaterials',
        component: () => import('pages/goods/sewingmaterials.vue')
        },
      {
        path: 'machinerytools',
        name: 'machinerytools',
        component: () => import('pages/goods/machinerytools.vue')
        },
      {
        path: 'smoothgrocery',
        name: 'smoothgrocery',
        component: () => import('pages/goods/smoothgrocery.vue')
        },
      {
        path: 'weldingmaterials',
        name: 'weldingmaterials',
        component: () => import('pages/goods/weldingmaterials.vue')
        },
      {
        path: 'wire',
        name: 'wire',
        component: () => import('pages/goods/wire.vue')
        },
      {
        path: 'hardwares',
        name: 'hardwares',
        component: () => import('pages/goods/hardwares.vue')
        },
      {
        path: 'iron',
        name: 'iron',
        component: () => import('pages/goods/iron.vue')
        },
      {
        path: 'aluminium',
        name: 'aluminium',
        component: () => import('pages/goods/aluminium.vue')
        },
      {
        path: 'chemicals',
        name: 'chemicals',
        component: () => import('pages/goods/chemicals.vue')
        },
      {
        path: 'fabricconstruction',
        name: 'fabricconstruction',
        component: () => import('pages/goods/fabricconstruction.vue')
        },
      {
        path: 'glasses',
        name: 'glasses',
        component: () => import('pages/goods/glasses.vue')
        },
      {
        path: 'woodpolywood',
        name: 'woodpolywood',
        component: () => import('pages/goods/woodpolywood.vue')
        },
        

      ]
    },
    {
      path: 'baseinfo',
      name: 'baseinfo',
      component: () => import('pages/baseinfo/baseinfo.vue'),
      children: [{
        path: 'company',
        name: 'company',
        component: () => import('pages/baseinfo/company.vue')
      },
      {
        path: 'supplier',
        name: 'supplier',
        component: () => import('pages/baseinfo/supplier.vue')
      },
      {
        path: 'customer',
        name: 'customer',
        component: () => import('pages/baseinfo/customer.vue')
      }
      ]
    },
    {
      path: 'warehouse',
      name: 'warehouse',
      component: () => import('pages/warehouse/warehouse.vue'),
      children: [{
        path: 'warehouseset',
        name: 'warehouseset',
        component: () => import('pages/warehouse/warehouseset.vue')
      },
      {
        path: 'binset',
        name: 'binset',
        component: () => import('pages/warehouse/binset.vue')
      },
      {
        path: 'binsize',
        name: 'binsize',
        component: () => import('pages/warehouse/binsize.vue')
      },
      {
        path: 'property',
        name: 'property',
        component: () => import('pages/warehouse/property.vue')
      },

      ]
    },
    {
      path: 'in_report',
      name: 'in_report',
      props: (route) => ({ inTableList: route.params.inTableList,
                            InOutImportForm: route.params.InOutImportForm,
                         }),     
      component: () => import('pages/stock/in_report.vue'),
      children: [{
        path: 'in_report',
        name: 'in_report',
        component: () => import('pages/stock/in_report.vue')
      }

      ]
    },
    {
      path: 'out_report',
      name: 'out_report',
      props: (route) => ({ outTableList: route.params.outTableList,
                            InOutExportForm: route.params.InOutExportForm,
                         }),     
      component: () => import('pages/stock/out_report.vue'),
      children: [{
        path: 'out_report',
        name: 'out_report',
        component: () => import('pages/stock/out_report.vue')
      }

      ]
    },
    {
      path: 'balance_report',
      name: 'balance_report',
      props: (route) => ({ inOutBalanceTableList: route.params.inOutBalanceTableList,
                            InOutBalanceForm: route.params.InOutBalanceForm,
                         }),     
      component: () => import('pages/stock/balance_report.vue'),
      children: [{
        path: 'balance_report',
        name: 'balance_report',
        component: () => import('pages/stock/balance_report.vue')
      }

      ]
    },
    {
      path: 'production_report',
      name: 'production_report',
      props: (route) => ({                   
                  unfinishedQuantityTableList: route.params.unfinishedQuantityTableList,
                  unfinishedPillowMattressTableList: route.params.unfinishedPillowMattressTableList,
                  unfinishedProductsTableList: route.params.unfinishedProductsTableList,
                  inlineStockTableList: route.params.inlineStockTableList,
                  inlinePillowMattressTableList: route.params.inlinePillowMattressTableList,
                  inlineProductTableList: route.params.inlineProductTableList,
                  POReportForm: route.params.POReportForm
                         }),     
      component: () => import('pages/stock/production_report.vue'),
      children: [{
        path: 'production_report',
        name: 'production_report',
        component: () => import('pages/stock/production_report.vue')
      }

      ]
    },
    {
      path: 'in_out_report',
      name: 'in_out_report',
      props: (route) => ({ inTableList: route.params.inTableList,
                            outTableList: route.params.outTableList,
                            InOutImportForm: route.params.InOutImportForm,
                            InOutExportForm: route.params.InOutExportForm
                         }),     
      component: () => import('pages/warehouse/in_out_report.vue'),
      children: [{
        path: 'in_out_report',
        name: 'in_out_report',
        component: () => import('pages/warehouse/in_out_report.vue')
      }

      ]
    },
    {
      path: 'in_out_balance_report',
      name: 'in_out_balance_report',
      props: (route) => ({ inOutBalanceTableList: route.params.inOutBalanceTableList,
                            InOutBalanceForm: route.params.InOutBalanceForm
                         }),       
      component: () => import('pages/warehouse/in_out_balance_report.vue'),
      children: [{
        path: 'in_out_balance_report',
        name: 'in_out_balance_report',
        component: () => import('pages/warehouse/in_out_balance_report.vue')
      }

      ]
    },
    {
      path: 'finance',
      name: 'finance',
      component: () => import('pages/finance/finance.vue'),
      children: [{
        path: 'capitallist',
        name: 'capitallist',
        component: () => import('pages/finance/capitallist.vue')
      },
      {
        path: 'freight',
        name: 'freight',
        component: () => import('pages/finance/freight.vue')
      }
      ]
    },
    {
      path: 'staff',
      name: 'staff',
      component: () => import('pages/staff/staff.vue'),
      children: [{
        path: 'stafflist',
        name: 'stafflist',
        component: () => import('pages/staff/stafflist.vue')
      },
      {
        path: 'stafflist_check_code',
        name: 'stafflist_check_code',
        component: () => import('pages/staff/stafflist_check_code.vue')
      },
      {
        path: 'stafftype',
        name: 'stafftype',
        component: () => import('pages/staff/stafftype.vue')
      }
      ]
    },
    {
      path: 'driver',
      name: 'driver',
      component: () => import('pages/driverlist/driver.vue'),
      children: [{
        path: 'driverlist',
        name: 'driverlist',
        component: () => import('pages/driverlist/driverlist.vue')
      },
      {
        path: 'dispatchlist',
        name: 'dispatchlist',
        component: () => import('pages/driverlist/dispatchlist.vue')
      }
      ]
    },
    {
      path: 'customerdn',
      name: 'customerdn',
      component: () => import('pages/customerdn/customer.vue'),
      children: [{
        path: 'customerdnlist',
        name: 'customerdnlist',
        component: () => import('pages/customerdn/customerdnlist.vue')
      },
      {
        path: 'customerpod',
        name: 'customerpod',
        component: () => import('pages/customerdn/pod.vue')
      }
      ]
    },
    {
      path: 'supplierasn',
      name: 'supplierasn',
      component: () => import('pages/supplierasn/supplier.vue'),
      children: [{
        path: 'supplierasnlist',
        name: 'supplierasnlist',
        component: () => import('pages/supplierasn/supplierasnlist.vue')
      },
      {
        path: 'supplierasnfinish',
        name: 'supplierasnfinish',
        component: () => import('pages/supplierasn/supplierasnfinish.vue')
      }
      ]
    },
    {
      path: 'uploadcenter',
      name: 'uploadcenter',
      component: () => import('pages/uploadcenter/upload.vue'),
      children: [{
        path: 'initializeupload',
        name: 'initializeupload',
        component: () => import('pages/uploadcenter/initializeupload.vue')
      },
      {
        path: 'addupload',
        name: 'addupload',
        component: () => import('pages/uploadcenter/addupload.vue')
      }
      ]
    },
    {
      path: 'downloadcenter',
      name: 'downloadcenter',
      component: () => import('pages/downloadcenter/download.vue'),
      children: [{
        path: 'downloadinbound',
        name: 'downloadinbound',
        component: () => import('pages/downloadcenter/downloadinbound.vue')
      }, {
        path: 'downloadoutbound',
        name: 'downloadoutbound',
        component: () => import('pages/downloadcenter/downloadoutbound.vue')
      }, {
        path: 'downloadstocklist',
        name: 'downloadstocklist',
        component: () => import('pages/downloadcenter/downloadstocklist.vue')
      }, {
        path: 'downloadgoodslist',
        name: 'downloadgoodslist',
        component: () => import('pages/downloadcenter/downloadgoodslist.vue')
      }, {
        path: 'downloadbinlist',
        name: 'downloadbinlist',
        component: () => import('pages/downloadcenter/downloadbinlist.vue')
        },


      ]
    }
  ]
}]

// Always leave this as last one
if (process.env.MODE !== 'ssr') {
  routes.push({
    path: '*',
    component: () => import('pages/Error404.vue')
  })
}

export default routes
